import { createContext } from 'react';

export const SampleDocumentContext = createContext<{
  documentId: string | null;
  setDocumentId: (id: string) => void;
}>({ documentId: null, setDocumentId: () => undefined });
